
import { schedulerIntegrations } from "../template/scheduler"

import * as customScheduler from '../customization/scheduler'

// function that embeded into the supported hooks
export const getSchedulerRequestSubmitObject = (integrations) => {

  if (integrations.length <= 0) return {}

  let dataTypes = []

  // console.log('integrations', integrations)

  integrations.forEach(i => {
    let a = i?.dataTypes ? i.dataTypes : []
    dataTypes = [...dataTypes, ...a]
  })

  return {
    scheduler: {
      integration_ids: integrations.map(i => i.id),
      data_types: dataTypes
    }
  }
}

export const getSchedulerTasks = (allSchedulers, schedulerId) => {
  const selected = allSchedulers.filter(i => i.id === schedulerId)
  return selected.length ? selected[0].tasks : []
}

export const getSchedulerConfigs = () => {

  let integrations = schedulerIntegrations
  let schedulerServer = {}
  let schedulerServerEnabled = false

  if (customScheduler?.schedulerIntegrations) {
    integrations = customScheduler?.schedulerIntegrations
  }

  if (customScheduler?.schedulerServer) {
    schedulerServer = customScheduler?.schedulerServer
    schedulerServerEnabled = true
  }

  const schedulerTaskKeys = []

  integrations.forEach(i => {
    i.tasks.forEach(i2 => {
      schedulerTaskKeys.push({
        id: i2.id,
        name: i2.name,
        description: i2.description
      })
    })
  })

  let configs = {
    schedulerServer: {
      enabled: schedulerServerEnabled,
      config: schedulerServer
    },
    getSchedulerTasks,
    getSchedulerRequestSubmitObject,
    schedulerIntegrations: integrations,
    schedulerIntegrationIds: integrations.map(i => i?.id),
    schedulerIntegrationTypes: integrations.map(i => {
      return {
        id: i.id,
        name: i.name
      }
    }),
    schedulerTaskKeys
  }

  return configs
}